// extracted by mini-css-extract-plugin
export default {"button":"Fv","primary":"Gv","fullWidth":"Hv","secondary":"Iv","nutrition":"Jv","underlined":"Kv","small":"Lv","medium":"Mv","info":"Nv","white":"Ov","border":"Pv","mango":"Qv","charcoal":"Rv","court":"Sv","green":"Tv","spark":"Uv","linkButton":"Vv","disabled":"Wv"};
    if(module.hot) {
      // 1730991502501
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  